import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DeviceCard from '../elements/DeviceCard';
import Button from '../elements/Button';
import Heading from '../elements/PageHeading';

import { types } from '../../utils/deviceTypes';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: auto;
  color: ${props => props.theme.secondary};
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px auto 0px;
  alignitems: 'center';
`;

const ManagementPage = ({
  t,
  target,
  startReplacement,
  startRetire,
  isRoot,
  startReprovisionDevice,
  startEnableFAT,
  startEnableOAT,
  startProvision,
  startIdentification,
  startDiscovery,
}) => (
  <Wrapper>
    <Heading text={t('management.device_management')} />
    <DeviceCard device={target || {}} />
    {target.lifeCycleStatus === 'READY' && (
      <Buttons>
        <Button onClick={startProvision}>{t('management.provision')}</Button>
        &nbsp;&nbsp;&nbsp;
        {target.deviceType !== 'encodingStation' && (
          <Button onClick={startEnableFAT}>{t('management.enableFAT')}</Button>
        )}
        &nbsp;&nbsp;&nbsp;
      </Buttons>
    )}

    {target.lifeCycleStatus === 'OPERATIONAL' && (
      <Buttons>
        <Button onClick={startReprovisionDevice}>
          {t('management.reprovision')}
        </Button>
        &nbsp;&nbsp;&nbsp;
        {target.deviceType !== 'selflyEncode' && (
          <Button onClick={startReplacement}>{t('management.replace')}</Button>
        )}
        &nbsp;&nbsp;&nbsp;
        <Button onClick={startRetire}>{t('management.retire')}</Button>
        &nbsp;&nbsp;&nbsp;
        {target.deviceType !== 'encodingStation' &&
          target.deviceType !== 'selflyEncode' && (
            <>
              <Button onClick={startEnableFAT}>
                {t('management.enableFAT')}
              </Button>
              &nbsp;&nbsp;&nbsp;
              <Button onClick={startEnableOAT}>
                {t('management.enableOAT')}
              </Button>
            </>
          )}
        &nbsp;&nbsp;&nbsp;
        {target.deviceType === 'smartCabinet' &&
          types[target.deviceType].subTypes.includes(target.deviceSubType) && (
            <Button onClick={startIdentification}>
              {t('management.identification')}
            </Button>
          )}
        &nbsp;&nbsp;&nbsp;
        {target.deviceType === 'smartCabinet' &&
          types[target.deviceType].subTypes.includes(target.deviceSubType) && (
            <Button onClick={startDiscovery}>
              {t('management.discovery_mode')}
            </Button>
          )}
      </Buttons>
    )}

    {target.lifeCycleStatus === 'RETIRED' && (
      <Buttons>
        <Button onClick={startReprovisionDevice}>
          {t('management.reprovision')}
        </Button>
        &nbsp;&nbsp;&nbsp;
      </Buttons>
    )}
  </Wrapper>
);

export default translate()(ManagementPage);
